import React from 'react'
import './OpcionesSeleccionadas.css'

//import logo from './logo_pdf.png'

import { connect } from 'react-redux'
import {
  getTotal,
  getOpcionesSeleccionadas,
  setVisibleDefault,
  toggleResumen,
  getTextoIva,
  getTextoGenerarPDF,
  getTextoGuardarConfiguraciones,
  getTextoCerrarSeleccionadas,
  getTextoEnviarCorreo,
  getTextoHeaderPdf,
  toggleUsuario,
  toggleOpcionesGuardadas,
  getOpcionesSeleccionadasPdf,
  toggleGeneratePdf,
  togglePdfLoading
} from '../../modules/reducer'

import { useTransition, animated } from 'react-spring'

import { IoIosCloseCircleOutline } from 'react-icons/io'
import { MdClear } from 'react-icons/md'
import { IconContext } from 'react-icons'

import MyPdfDownloadLink from './MyPdfDownloadLink'

import Pdf from './Pdf'

import { gaEvent } from '../../Cookies'

const gaEventPdf = opcionesPdf => {
  opcionesPdf.forEach(estancia => {
    estancia.acabados.forEach(acabado => {
      acabado.opciones.forEach(opcion => {
        gaEvent({
          category: 'Opción en pdf',
          action: `${estancia.gaTitle} ${acabado.gaTitle}`,
          label: opcion.gaTitle
        })
      })
    })
  })
}

const OpcionesSeleccionadas = ({
  open,
  total,
  opciones,
  setVisibleDefault,
  toggleResumen,
  textoIva,
  textoGenerarPDF,
  textoGuardarConfiguraciones,
  textoCerrarSeleccionadas,
  textoEnviarCorreo,
  toggleUsuario,
  idUsuario,
  toggleOpcionesGuardadas,
  opcionesPdf,
  generatePdf,
  toggleGeneratePdf,
  togglePdfLoading,
  srcLogo,
  srcLogoPdf,
  nombrePdf,
  textoHeaderPdf
}) => {
  const transitions = useTransition(opciones, item => item.id, {
    from: { opacity: 0, transform: 'translate3d(100%,0,0)' },
    enter: { opacity: 1, transform: 'translate3d(0%,0,0)' },
    leave: { opacity: 0, transform: 'translate3d(-50%,0,0)' }
  })

  return (
    <div className="resumen" style={{ display: open ? 'block' : 'none' }}>
      <section className="modal-main">
        <div className="close-resumen" onClick={e => toggleResumen()}>
          <IconContext.Provider
            value={{
              color: '#434343',
              size: '2em'
            }}
          >
            <MdClear />
          </IconContext.Provider>
        </div>

        <div
          className="container-resumen grid-center-noGutter"
          style={{
            height: opciones.length * 120 + 85
          }}
        >
          <img style={{ height: 70 }} src={srcLogo} alt="" />
          {transitions.map(({ item, props, key }) => {
            return (
              <animated.div
                key={key}
                className="row-container-resumen col-10_sm-12 grid-middle-noGutter"
                style={{
                  top: 120 * item.index + 85,
                  opacity: props.opacity,
                  transform: props.transform
                }}
              >
                <div className="row-icono-container-resumen">
                  <img
                    className="row-icono-resumen"
                    src={item.srcIcono}
                    alt=""
                  />
                </div>
                <div className="row-texto-container-resumen">
                  <div className="acabado-title-resumen">
                    {item.acabadoTitle}
                  </div>
                  <div className="title-resumen">{item.title}</div>
                  <div className="subtitle-resumen">{item.subtitle}</div>
                  <div>{`${item.precio}€`}</div>
                </div>
                {!item.default ? (
                  <div className="row-close-container">
                    <IconContext.Provider
                      value={{ color: '#434343', size: '2em' }}
                    >
                      <IoIosCloseCircleOutline
                        onClick={e =>
                          setVisibleDefault(item.idAcabado, item.id)
                        }
                      />
                    </IconContext.Provider>
                  </div>
                ) : null}
              </animated.div>
            )
          })}
        </div>
        <div className="grid-center-noGutter">
          <div className="col-10_sm12" style={{ marginBottom: 10 }}>
            <span className="total-resumen">TOTAL:</span>
            <span className="total-numero-resumen">{total}€</span>
            <div className="iva-resumen">{textoIva}</div>

            {idUsuario !== 0 ? (
              <div style={{ marginTop: 10 }}>
                <label class="checkbox">
                  <input id="send-pdf" type="checkbox" />
                  {textoEnviarCorreo}
                </label>
              </div>
            ) : null}
          </div>
          <div className="col-10_sm12 grid-center-noGutter">
            <div className="col-9_sm-12">
              <div
                className="button boton-generar-resumen"
                onClick={e => {
                  gaEvent({
                    category: 'Generar pdf',
                    action: 'Generar pdf'
                  })
                  gaEventPdf(opcionesPdf)

                  togglePdfLoading()
                  toggleGeneratePdf()
                }}
              >
                {textoGenerarPDF}
              </div>

              {generatePdf ? (
                <div>
                  <MyPdfDownloadLink
                    document={
                      <Pdf
                        opciones={opcionesPdf}
                        total={total}
                        textoIva={textoIva}
                        srcLogo={srcLogoPdf}
                        textoHeaderPdf={textoHeaderPdf}
                      />
                    }
                    mail={
                      idUsuario === 0
                        ? false
                        : document.getElementById('send-pdf').checked
                    }
                    idUsuario={idUsuario}
                    idEnlace="download-pdf"
                  />
                </div>
              ) : null}

              <a
                id="download-pdf"
                href="http://www.google.es"
                style={{ display: 'none' }}
                download={`${nombrePdf}.pdf`}
              >
                a
              </a>

              <div
                className="button boton-generar-resumen"
                onClick={e => {
                  idUsuario === 0
                    ? toggleUsuario(true)
                    : toggleOpcionesGuardadas()
                }}
              >
                {textoGuardarConfiguraciones}
              </div>

              <div
                className="button boton-generar-resumen"
                style={{ backgroundColor: '#434343' }}
                onClick={e => toggleResumen()}
              >
                {textoCerrarSeleccionadas}
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

const mapStateToProps = ({ reducer }, ownProps) => {
  return {
    idUsuario: typeof reducer.idUsuario === 'undefined' ? 0 : reducer.idUsuario,
    total: getTotal(reducer),
    opciones: getOpcionesSeleccionadas(reducer),
    opcionesPdf: getOpcionesSeleccionadasPdf(reducer),
    open: reducer.openResumen,
    generatePdf: reducer.generatePdf,
    srcLogo: reducer.srcLogoResumen,
    srcLogoPdf: reducer.srcLogoPdf,
    nombrePdf: reducer.nombrePdf,
    textoIva: getTextoIva(reducer),
    textoGenerarPDF: getTextoGenerarPDF(reducer),
    textoGuardarConfiguraciones: getTextoGuardarConfiguraciones(reducer),
    textoCerrarSeleccionadas: getTextoCerrarSeleccionadas(reducer),
    textoEnviarCorreo: getTextoEnviarCorreo(reducer),
    textoHeaderPdf:getTextoHeaderPdf(reducer)
  }
}

const mapDispatchToProps = {
  setVisibleDefault,
  toggleResumen,
  toggleUsuario,
  toggleOpcionesGuardadas,
  toggleGeneratePdf,
  togglePdfLoading
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OpcionesSeleccionadas)
